<template>
  <section class="housemaid-quote-info">
    <div class="box">
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Insured Period</td>
          <td
            v-copy="formData.insurance_period"
            :class="{'green-tip':handleCompare('insurance_period')}">{{ formData.insurance_period}}</td>
        </tr>
        <tr class="tr">
          <td>Expected Insured Period</td>
          <td
            v-copy="formData.period_date"
            :class="{'green-tip':handleCompare('period_date')}">
            {{ formData.period_date }}
            <span
              v-if="formData.is_eff_dt_delay && formData.pcy_stts != 425"
              class="asap">(ASAP)</span>
          </td>
        </tr>
        <tr class="tr">
          <td>Total Price</td>
          <td
            v-if="showAmount"
            v-copy="amount"
            :class="{'green-tip':isChange}">{{ showAmount | formatMoney(2, true) }}</td>
        </tr>
        <tr class="tr">
          <td>Referrer</td>
          <td
            v-if="referrer"
          >
            <referrer-info :referrer="referrer"></referrer-info>
          </td>
        </tr>
        <tr
          v-if="formData.discount_str&&!isFina"
          class="tr">
          <td>Referrer Discount</td>
          <span>{{formData.discount_str}}</span>
        </tr>
        <tr
          v-if="!isEndorse"
          class="tr">
          <td>Policy Number </td>
          <td
            v-copy="formData.pcy_no"
            :class="{'green-tip':handleCompare('pcy_no')}">{{ formData.pcy_no  }}</td>
        </tr>
        <tr
          v-else
          class="tr">
          <td>Endorsement Number </td>
          <td
            v-copy="formData.endorser_no"
            :class="{'green-tip':handleCompare('endorser_no')}">{{ formData.endorser_no  }}</td>
        </tr>
        <tr class="tr">
          <td>Policy Reference Code </td>
          <td
            v-copy="formData.order_sn"
            :class="{'green-tip':handleCompare('order_sn')}">{{ formData.order_sn }}</td>
        </tr>
      </table>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in ageLimit.items"
        :key="'ageLimit' + excessIndex">
        <table
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: ageLimit.title }}</h3>
          <tr
            v-if="excessIndex==0"
            class="tr th">
            <th>Item</th>
            <th>Information</th>
          </tr>
          <tr
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'ageLimit-' + excessIndex + subIndex"
            class="tr">
            <td>{{ subItem.item }}</td>
            <td
              v-copy="subItem.premium"
            >{{ subItem.premium }}</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="box">
      <div
        v-for="(excessItem, excessIndex) in coverageList.items"
        :key="'coverage' + excessIndex">
        <table
          v-if="excessItem.sub_items.length>0"
          class="table">
          <h3 :class="{'table-title':excessIndex>0}">{{ excessItem.sub_title? excessItem.sub_title: coverageList.title }}</h3>
          <tr
            v-if="excessIndex==0"
            class="tr th">
            <th>Item</th>
            <th>Information</th>
          </tr>
          <tr
            v-for="(subItem, subIndex) in excessItem.sub_items"
            :key="'coverage-' + excessIndex + subIndex"
            class="tr">
            <td>{{ subItem.item }}</td>
            <td
              v-copy="subItem.premium"
            >{{ subItem.premium }}</td>
          </tr>
          <tr class="tr">
            <td>Coverage Remark</td>
            <td
              v-copy="changeLineData(formData.cvr_remark)"
              :class="{'green-tip':handleCompare('quote_remark')}"
              v-html="changeLineData(formData.cvr_remark)"></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="box">
      <h3>Excess</h3>
      <table class="table">
        <tr
          v-for="(inItem, index) in excessList"
          :key="'excessList'+index"
          class="tr">
          <td>{{ inItem.item }}</td>
          <td
            v-copy="inItem.premium"
          >{{ inItem.premium }}</td>
        </tr>
        <tr class="tr">
          <td>Excess Remark</td>
          <td
            :class="{'green-tip':handleCompare('quote_remark')}"
            v-html="changeLineData(formData.quote_remark)"></td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h3>Policy Detail</h3>
      <table class="table mg-b-10">
        <tr class="tr">
          <td>Expected Effective Date</td>
          <td
            v-copy="formData.pcy_cmnt_date"
            :class="{'green-tip':handleCompare('pcy_cmnt_date')}">{{ formData.pcy_cmnt_date }}</td>
        </tr>
        <tr class="tr">
          <td>Expected Expiry Date</td>
          <td
            v-copy="formData.pcy_expry_date"
            :class="{'green-tip':handleCompare('pcy_expry_date')}">{{ formData.pcy_expry_date  }}</td>
        </tr>
        <tr
          v-if="formData.period_of_cvr"
          class="tr">
          <td>Period of Insurance</td>
          <td
            v-copy="getAllOptionName21('period', formData.period_of_cvr)"
            :class="{'green-tip':handleCompare('period_of_cvr')}">{{ getAllOptionName21('period', formData.period_of_cvr) }}</td>
        </tr>
        <tr class="tr">
          <td>Coverage</td>
          <td
            v-copy="getName(formData.coverage_id)"
            :class="{'green-tip':handleCompare('coverage_id')}">{{getName(formData.coverage_id)}}</td>
        </tr>
        <tr
          v-if="option_benefits.length>0"
          class="tr">
          <td>Optional Benefits</td>
          <td>
            <span
              v-for="(item,index) in option_benefits"
              :key="'extra'+index"
              v-copy="item.item"
              :class="{'green-tip':handleCompare('option_benefits')}">{{item.item}}<br></span>
          </td>
        </tr>
      </table>
    </div>

    <div class="box">
      <h3>Policyholder Detail</h3>
      <table class="table">
        <tr class="tr">
          <td>Title</td>
          <td
            v-copy="getOptionName('titleOptions', formData.isrd_title)"
            :class="{'green-tip':handleCompare('isrd_title')}">{{ getOptionName('titleOptions', formData.isrd_title) }}</td>
        </tr>
        <tr class="tr">
          <td>Occupation</td>
          <td
            v-copy="formData.occ"
            :class="{'green-tip':handleCompare('occ')}">{{  formData.occ }}</td>
        </tr>
        <tr class="tr">
          <td>Last Name</td>
          <td
            v-copy="formData.isrd_lst_nm"
            :class="{'green-tip':handleCompare('isrd_lst_nm')}">{{ formData.isrd_lst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>First Name</td>
          <td
            v-copy="formData.isrd_fst_nm"
            :class="{'green-tip':handleCompare('isrd_fst_nm')}">{{ formData.isrd_fst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>Mobile Number</td>
          <td
            v-copy="formData.mobile_no"
            :class="{'green-tip':handleCompare('mobile_no')}">{{ formData.mobile_no }}</td>
        </tr>
        <tr class="tr">
          <td>Date of Birth</td>
          <!-- <span>{{birthMethod(formData.isrd_dob)}}</span> -->
          <td
            v-copy="formData.isrd_dob_date"
            :class="{'green-tip':handleCompare('isrd_dob_date')}">{{ formData.isrd_dob_date }}</td>
        </tr>
        <tr class="tr">
          <td>HKID Number</td>
          <td
            v-copy="formData.id_no"
            :class="{'green-tip':handleCompare('id_no')}">{{ formData.id_no }}</td>
        </tr>
        <tr class="tr">
          <td>Email</td>
          <td
            v-copy="formData.email"
            :class="{'green-tip':handleCompare('email')}">
            {{ formData.email }}
            <email-tooltip :email="formData.email"></email-tooltip>
          </td>
        </tr>
      </table>
    </div>
    <div class="box">
      <span class="title">Proposed Location of Risk</span>
      <table class="table">
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="formData.addr_room"
            :class="{'green-tip':handleCompare('addr_room')}">{{ formData.addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td
            v-copy="formData.addr_floor"
            :class="{'green-tip':handleCompare('addr_floor')}">{{ formData.addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="formData.addr_block"
            :class="{'green-tip':handleCompare('addr_block')}">{{ formData.addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="formData.addr_building"
          >{{ formData.addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="formData.addr_street"
            :class="{'green-tip':handleCompare('addr_street')}">{{ formData.addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td
            v-copy="getAreaName('district', formData.addr_district)"
            :class="{'green-tip':handleCompare('addr_district')}">{{ getAreaName('district', formData.addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td
            v-copy="getAreaName('area', formData.addr_area)"
            :class="{'green-tip':handleCompare('addr_area')}">{{ getAreaName('area', formData.addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', formData.addr_region)"
            :class="{'green-tip':handleCompare('addr_region')}">{{ getAreaName('region', formData.addr_region) }}</td>
        </tr>
      </table>
    </div>
    <div
      class="box">
      <span class="title">Correspondence Address</span>
      <table
        class="table">
        <tr class="tr">
          <td>Is your Correspondence Address same as Proposed Location of Risk?</td>
          <td
            v-copy="getOptionName('yesNoOptions', formData.is_addr_same_ind)"
            :class="{'green-tip':handleCompare('is_addr_same_ind')}">{{ getOptionName('yesNoOptions', formData.is_addr_same_ind) }}</td>
        </tr>
        <tr class="tr">
          <td>Room</td>
          <td
            v-copy="formData.cor_addr_room"
            :class="{'green-tip':handleCompare('cor_addr_room')}">{{ formData.cor_addr_room }}</td>
        </tr>
        <tr class="tr">
          <td>Floor</td>
          <td :class="{'green-tip':handleCompare('cor_addr_floor')}">{{ formData.cor_addr_floor }}</td>
        </tr>
        <tr class="tr">
          <td>Block</td>
          <td
            v-copy="formData.cor_addr_block"
            :class="{'green-tip':handleCompare('cor_addr_block')}">{{ formData.cor_addr_block }}</td>
        </tr>
        <tr class="tr">
          <td>Building / Estate</td>
          <td
            v-copy="formData.cor_addr_building"
            :class="{'green-tip':handleCompare('cor_addr_building')}">{{ formData.cor_addr_building }}</td>
        </tr>
        <tr class="tr">
          <td>Street</td>
          <td
            v-copy="formData.cor_addr_stree"
            :class="{'green-tip':handleCompare('cor_addr_street')}">{{ formData.cor_addr_street }}</td>
        </tr>
        <tr class="tr">
          <td>District</td>
          <td
            v-copy="getAreaName('district', formData.cor_addr_district)"
            :class="{'green-tip':handleCompare('cor_addr_district')}">{{ getAreaName('district', formData.cor_addr_district) }}</td>
        </tr>
        <tr class="tr">
          <td>Area</td>
          <td
            v-copy="getAreaName('area', formData.cor_addr_area)"
            :class="{'green-tip':handleCompare('cor_addr_area')}">{{ getAreaName('area', formData.cor_addr_area) }}</td>
        </tr>
        <tr class="tr">
          <td>Country / Region</td>
          <td
            v-copy="getAreaName('region', formData.cor_addr_region)"
            :class="{'green-tip':handleCompare('cor_addr_region')}">{{ getAreaName('region', formData.cor_addr_region) }}</td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h3>Domestic Helper’s Information</h3>
      <table class="table">
        <tr class="tr">
          <td>Title</td>
          <td>
            <span
              v-copy="getOptionName('titleOptions', formData.domestic_title)"
              :class="{'green-tip':handleCompare('domestic_title')}">{{ getOptionName('titleOptions', formData.domestic_title) }}</span>
          </td>
        </tr>
        <!--        <div class="tr">-->
        <!--          <span>Name</span>-->
        <!--          <span :class="{'green-tip':handleCompare('full_name')}">{{ formData.full_name }}</span>-->
        <!--        </div>-->
        <tr class="tr">
          <td>Last Name</td>
          <td
            v-copy="formData.domestic_lst_nm"
            :class="{'green-tip':handleCompare('domestic_lst_nm'),'key-alt-down':keyAltDownCopy}">{{ formData.domestic_lst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>First Name</td>
          <td
            v-copy="formData.domestic_fst_nm"
            :class="{'green-tip':handleCompare('domestic_fst_nm'),'key-alt-down':keyAltDownCopy}">{{ formData.domestic_fst_nm }}</td>
        </tr>
        <tr class="tr">
          <td>HKID/Passport Number</td>
          <td
            v-copy="formData.domestic_id_no"
            :class="{'green-tip':handleCompare('domestic_id_no')}">{{ formData.domestic_id_no }}</td>
        </tr>
        <tr class="tr">
          <td>Position/Duties</td>
          <td
            v-copy="getAllOptionName21('duties', formData.duty_id)"
            :class="{'green-tip':handleCompare('duty_id')}">{{ getAllOptionName21('duties', formData.duty_id) }}</td>
        </tr>
        <tr class="tr">
          <td>Date of Birth</td>
          <td
            v-copy="formData.domestic_dob_date"
            :class="{'green-tip':handleCompare('domestic_dob_date')}">{{ formData.domestic_dob_date }}</td>
        </tr>
        <tr class="tr">
          <td>Nationality</td>
          <!-- <span>{{ getAllOptionName21('nationality', formData.nationality_id) }}</span> -->
          <td
            v-copy=" getOptionName('', formData.nationality_id, nationalityOptions)"
            :class="{'green-tip':handleCompare('nationality_id')}">{{ getOptionName('', formData.nationality_id, nationalityOptions) }}</td>
        </tr>
        <tr class="tr">
          <td>Monthly Salary</td>
          <td
            v-copy="monthly_salary"
            :class="{'green-tip':handleCompare('monthly_salary')}">{{ formData.monthly_salary | formatMoney(2, true) }}</td>
        </tr>
      </table>
    </div>
    <div class="box">
      <h3>Remark(s)</h3>
      <table class="table">
        <tr class="tr">
          <td>Remark</td>
          <td
            v-copy="changeLineData(formData.cs_manual_remark)"
            :class="{'green-tip':handleCompare('cs_manual_remark')}"
            v-html="changeLineData(formData.cs_manual_remark)"></td>
        </tr>
      </table>
    </div>
  </section>
</template>
<script>
import dayjs from 'dayjs'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import OMath from '@/utils/math'
import ReferrerInfo from '@/views/records/policy/components/info/referrer-info'

export default {
  name: 'HousemaidPolicyInfo',
  components: {ReferrerInfo},
  mixins: [MixinOptions, MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    preFormData: {
      type: Object,
      default: () => ({})
    },
    showAmount: {
      type: [String,Number],
      default: ''
    },
    isChange: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('common', ['nationalityOptions']),
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    amount(){
      return  OMath.formatMoney(this.showAmount, 2,true)
    },
    monthly_salary(){
      let {monthly_salary} = this.formData||{}
      return  OMath.formatMoney(monthly_salary, 2,true)

    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    sidebarPremium() {
      let {quote_coverage_list={}} =this.formData||{}
      if(!quote_coverage_list) {
        return []
      }
      let { sidebar_premium=[]} =quote_coverage_list||{}
      if(sidebar_premium.length<=0)return  []
      return sidebar_premium
    },
    option_benefits(){
      let {quote_coverage_list={}} = this.formData||{}
      let {more_benefit={}} = quote_coverage_list||{}
      let {sub_items={}} = more_benefit||{}
      let arr =[]
      if(sub_items){
        arr = Object.entries(sub_items).map(item=>item[1])
      }
      return arr
    },
    pcy_end_dt() {
      const { period_of_cvr, pcy_cmnt_dt } = this.formData
      if(pcy_cmnt_dt && period_of_cvr) {
        if(period_of_cvr >= 1) {
          return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
        }
        else {
          return dayjs(pcy_cmnt_dt).add(Number(period_of_cvr)*10, 'months').format('YYYY-MM-DD')
        }
        // return dayjs(pcy_cmnt_dt).add(period_of_cvr, 'years').format('YYYY-MM-DD')
      }
      return ''
    },
    localAllOptions() {
      return this.allOptions21
    },
    isEndorse(){
      return [30,40].includes(this.formData.type)
    },
    isDoula() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    isDriver() {
      const { duty_id } = this.formData
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { is_driver } = data || {}
      return !!is_driver
    },
    coverageOptions() {
      const { coverage = [] } = this.localAllOptions
      if(this.isPartTime) {
        return coverage.filter(item => item.part_time === 1)
      }
      if(this.isDriver) {
        return coverage.filter(item => item.id === 2)
      }
      return coverage
    },
    showEndorsementPremium() {
      const {type} = this.formData
      return [30, 40, 50].includes(type)
    },

    coverageList(){
      let {quote_coverage_list} = this.formData||{}
      let {coverage={}} = quote_coverage_list||{}
      return  coverage
    },
    ageLimit(){
      let {quote_coverage_list} = this.formData||{}
      let {age_limit={}} = quote_coverage_list||{}
      return  age_limit
    },
    excessList(){
      let {quote_coverage_list} = this.formData||{}
      let {excess} = quote_coverage_list||{}
      let {items} = excess||{}
      if(items){
        return items[0].sub_items
      }
      return  []
    },
    compareList(){
      let {type} = this.formData||{}
      let nowData = this.formData||{}
      let pre = this.preFormData||{}
      if(type!=50)return []
      let arr =  Object.keys(nowData).reduce((result,key)=>{
        if(nowData[key]!=pre[key]){
          result.push(key)
        }
        return result
      },[])
      return arr||[]
    }
  },
  watch: {
    'formData.nationality_id': {
      immediate: true,
      deep: true,
      handler(val) {
        if(val) {
          this.updateNationalityOptions(val)
        }
      }
    }
  },
  methods: {
    ...mapActions('common', ['updateNationalityOptions']),
    handleCompare(filed){
      let {type} = this.formData
      if(type!=50) return false
      return  this.compareList.includes(filed)?true:false
    },
    getName(id){
      let data = this.coverageOptions.filter(item=>{
        return item.id==id
      })
      return data.length>0?data[0].name:''
    },
    remark(name){
      let data = this.formData[name]||''
      return data?data.replace(/\n/g, '<br/>'):'-'
    }
  }
}
</script>
<style lang="scss" scoped>
.housemaid-quote-info{
  .box {
    margin-bottom: 15px;
  }
  .title {
    display: block;
    padding-bottom: 15px;
    font-size: 16px;
    font-weight: 400;
    color: #616266;
  }
  .table-title {
    display: inline-block;
    padding-bottom: 2px;
    padding-left: 5px;
    font-size: 12px;
    font-weight: bold;
    color: #909399;
    line-height: 15px;
  }
  .green-tip{
    color: #0E9A00!important;
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
</style>
